import axios from 'axios';

const authUrl = process.env.REACT_APP_AUTH_API_URL;
export const lmsUrl = process.env.REACT_APP_LMS_API_URL;
const billingUrl = process.env.REACT_APP_BILLING_API_URL;
const placementUrl = process.env.REACT_APP_PLACEMENT_API_URL;
export { placementUrl };

export const axiosInstance = axios.create({
  baseURL: placementUrl + '/api/v1/',
  timeout: 30000, // 30 second timeout
  headers: {},
});

export const axiosInstanceV2 = axios.create({
  baseURL: authUrl + '/api/v1',
  timeout: 30000,
  headers: {},
});

export const axiosInstanceV1 = axios.create({
  baseURL: authUrl + '/api/v1',
  timeout: 30000,
  headers: {},
});

export const billingdataInstance = axios.create({
  baseURL: billingUrl + '/api/v1',
  timeout: 30000,
  headers: {},
});

export const axiosPlacement = axios.create({
  baseURL: placementUrl + '/api/v1',
  timeout: 30000,
  headers: {},
});

export const axiosLMS = axios.create({
  baseURL: lmsUrl + '/api/v1',
  timeout: 30000,
  headers: {},
});

const setupInterceptors = (instance) => {
  // Request interceptor
  instance.interceptors.request.use((config) => {
    let token = '';
    let refreshToken = '';

    if (process.env.REACT_APP_DEV_SKIP_AUTH === '1') {
      config.headers['x-skip-auth'] = '1';
    }

    if (localStorage.getItem('accessToken')) {
      token = localStorage.getItem('accessToken') || '';
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        config.headers['Authorization'] = '';
        window.location.href = '/login';
      }
    }

    if (localStorage.getItem('refreshToken')) {
      refreshToken = localStorage.getItem('refreshToken') || '';
      if (refreshToken) {
        config.headers['x-refresh-token'] = `${refreshToken}`;
      } else {
        config.headers['x-refresh-token'] = '';
      }
    }

    config.headers['x-app-name'] = 'placement';
    config.params = config.params || {};
    return config;
  });

  // Response interceptor with token refresh + network retry
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Network error retry (up to 3 attempts with exponential backoff)
      if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        originalRequest._retryCount = originalRequest._retryCount || 0;

        if (originalRequest._retryCount < 3) {
          originalRequest._retryCount += 1;
          await new Promise((r) => setTimeout(r, Math.pow(2, originalRequest._retryCount) * 1000));
          return instance(originalRequest);
        }
      }

      // 401 — try refreshing the token once before logging out
      if (error.response?.status === 401 && !originalRequest._authRetried) {
        originalRequest._authRetried = true;
        const refreshToken = localStorage.getItem('refreshToken');

        if (refreshToken) {
          try {
            const refreshResponse = await axios.post(
              `${authUrl}/api/v1/auth/refresh-token`,
              { refreshToken }
            );
            const newToken = refreshResponse.data?.data?.accessToken || refreshResponse.data?.accessToken;

            if (newToken) {
              localStorage.setItem('accessToken', newToken);
              originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
              return instance(originalRequest);
            }
          } catch (refreshErr) {
            // Refresh failed — fall through to logout
          }
        }

        localStorage.clear();
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

// Apply interceptors to all instances
setupInterceptors(axiosInstance);
setupInterceptors(axiosInstanceV2);
setupInterceptors(axiosInstanceV1);
setupInterceptors(billingdataInstance);
setupInterceptors(axiosPlacement);
setupInterceptors(axiosLMS);

export default axiosInstance;
